import './sentry.client';
import './global-fetch-patch';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { BUILD_ID } from '@/config/build';

// 🔥 BUILD ID - verify new bundle is loaded
console.info('[BUILD]', BUILD_ID);

// Note: Early fetch patch is now in index.html for earlier execution
console.log('[MAIN] VITE_API_BASE_URL at runtime:', import.meta.env.VITE_API_BASE_URL);

// Global error handlers for debugging
window.addEventListener('error', (e) => {
  console.error('[GLOBAL ERROR]', e.error?.message, e.error?.stack);
});

window.addEventListener('unhandledrejection', (e) => {
  console.error('[UNHANDLED REJECTION]', e.reason);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
